<template>
  <div>
    <v-btn
      fab
      color="primary"
      class="add-button-fab mb-2"
      @click="addQUnit()"
      :disabled="!can_create_units"
    >
      <v-icon small>mdi-plus-thick</v-icon>
    </v-btn>
    <modal-dialog-form
      :title="modal_title"
      :showModalDialog="showModalDialog"
      :fields_to_collect="creation_fields_to_collect"
      :submit_button_text="'Add'"
      @close-dialog="toggle_dialog"
      @submit="process_form"
      :message="message"
    >
    </modal-dialog-form>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import QUnit from '@/api/QUnit'
// import AddQUnitForm from './AddQUnitForm'
import ProcessSelectComponent from './ProcessSelectComponent'
import DependingProcessSelectComponent from './DependingProcessSelectComponent'
import ExplorerDirectoryPath from '@/components/explorer/ExplorerDirectoryPath'
import DynamicForm from '@/components/DynamicForm'
import ModalDialogForm from './ModalDialog'

export default {
  name: 'ExplorerHeaderAddButton',
  components: {
    ProcessSelectComponent,
    DependingProcessSelectComponent,
    ExplorerDirectoryPath,
    DynamicForm,
    ModalDialogForm,
  },
  data() {
    return {
      can_create_units: false,
      showModalDialog: false,
      loading: false,
      addUnitBussinessProcess: '',
      addUnitParentProcess: '',
      fields_to_collect: [],
      creation_fields_to_collect: [],
      jsdata: '',
      rules: {
        required: (v) => !!v || 'Field is mandatory',
      },
      depending_fields: [],
      valid: null,
      disable: false,
      alert: false,
      err: '',
      message: '',
      depending_choices: [],
      depending_process_value: '',
      depending_value: '',
      // New
      modal_title: '',
    }
  },
  computed: {
    ...mapState([
      'sitePath',
      'current_business_process',
      'current_business_process_name',
      'form_process',
      'processID',
      'searchText',
      'filterFormData',
      'current_page_number',
      'current_unit',
      'activeDirectory',
      'qdirectory',
      'explorer_sort_by',
      'explorer_sort_desc'
    ]),
  },
  mounted: function () {
    this.checkCanCreateUnit(this.current_business_process)
  },
  watch: {
    // if route change check create permission
    $route(to, _from) {
      this.checkCanCreateUnit(this.current_business_process)
    },
  },
  methods: {
    addQUnit(business_process, parent_qunit_id) {
      parent_qunit_id = parent_qunit_id || ''
      if (!business_process) {
        business_process = this.current_business_process
      }
      this.message = ""
      if (business_process) {
        QUnit.getFieldsDefinitionToCollectDuringCreation(
          this.sitePath,
          business_process,
          parent_qunit_id,
        )
          .then((data) => {
            this.creation_fields_to_collect = data['fields']
            this.jsdata = data['js']
            this.addUnitBussinessProcess = business_process
            this.addUnitParentProcess = parent_qunit_id
            this.showModalDialog = true
            // TODO:Lang
            this.modal_title = 'Add new ' + this.current_business_process_name
            this.submit_button_caption = 'Add'
          })
          .catch((error) => {
            this.creation_form_error_message = error.body || error.response.data
          })
      } else {
        this.creation_form_error_message = 'no business_process provided!'
        // this.$refs.addmodal.show()
      }
    },
    checkCanCreateUnit(business_process) {
      this.can_create_units = false
      if (!business_process) business_process = this.current_business_process
      if (business_process) {
        QUnit.canCreate(this.sitePath, business_process)
          .then((data) => {
            this.can_create_units = data
          })
          .catch((error) =>
            // TODO:
            console.log(error),
          )
      }
    },
    toggle_dialog() {
      this.addUnitBussinessProcess = ''
      this.addUnitParentProcess = ''
      this.fields_to_collect = []
      this.creation_fields_to_collect = []
      this.showModalDialog = false
      this.valid = true
      this.disable = false
    },
    ...mapActions(['EXPLORE_UNITS']),
    ...mapMutations(['SET_BUSINESS_PROCESS', 'SET_CURRENT_UNIT']),
    process_form: function (form_data) {
      let current_item_uid = this.current_unit['uid']
      console.log('AddButton, form submit', form_data)
      form_data.append('business_process', this.addUnitBussinessProcess)
      form_data.append('parent_process', this.addUnitParentProcess)
      this.$root.$loader.show('Sending...',{})
      QUnit.createUnit(
        this.sitePath,
        form_data,
        this.addUnitBussinessProcess,
        this.addUnitParentProcess,
      )
        .then((data) => {
          if (this.addUnitBussinessProcess == this.current_business_process) {
            current_item_uid = data.uid
          }
          //TODO: no harcode units_sort_by units_sort_desc
          console.log('ExplorerHeaderAddButton Warning harcoded two params')
          this.toggle_dialog()
          this.$root.$loader.hide()
          this.SET_CURRENT_UNIT(data)
          this.EXPLORE_UNITS({
            site: this.sitePath,
            bp_reference: this.current_business_process,
            process_id: this.processID,
            search_text: this.searchText,
            filters_form: this.filterFormData,
            units_page: this.current_page_number,
            units_sort_by: this.explorer_sort_by,
            units_sort_desc: this.explorer_sort_desc,
            pk: current_item_uid
          })
        })
        .catch((err) => {
          this.$root.$loader.hide()
          console.log('Error', err)
          this.render_form_errors(err)
          // this.alert = true
        })
    },
  },
}
</script>


<style lang="scss">
@import '@/sass/explorer.scss';
</style>
